import React from 'react'
import { AmpIFrame } from '../../../publication/Embed/amp/AmpIFrame'
import { StyledContent } from '../../../publication/Embed/amp/AmpStyledContent.styled'

export interface AmpOmnyProps {
    frameborder: 0 | 1
    height: number
    link: string
}

const embedLink = '/embed'

const processEmbedLink = (link: string) => {
    if (link.indexOf(embedLink) === -1) {
        return `${link}${embedLink}`
    }
    return link
}

export const AmpOmny: React.FC<AmpOmnyProps> = (props) => (
    <StyledContent>
        <AmpIFrame
            width={undefined}
            height={props.height}
            src={processEmbedLink(props.link)}
            frameborder={props.frameborder}
            layout={'fixed-height'}
            allowSameOrigin={true}
            allowPopups={true}
            allowForms={false}
        />
    </StyledContent>
)
